import { VehicleTelemetryRepositoryFactory } from 'core/repositories/FMS/VehicleTelemetryRepository';
import { createDependency } from 'services/createDependency';

export const [useVehicleTelemetryRepositoryFactory, withVehicleTelemetryRepositoryFactory] = createDependency<VehicleTelemetryRepositoryFactory>();
